import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';

import { PortalProveedorService } from '../../../services/api.services';
import { IssueFront, IssueFrontSelection } from '../../../models/api.models';


import { ElipsisModalComponent } from '../../shared/elipsis-modal/elipsis-modal.component';
import { AddComentarioModalComponent } from '../../shared/add-comentario-modal/add-comentario-modal.component';
import { FaltaMaterialComponent } from '../../shared/falta-material/falta-material.component';
import { IssueImageComponent } from '../../shared/issue-image/issue-image.component';
import { ContactDataComponent } from '../../shared/contact-data/contact-data.component';


@Component({
  selector: 'app-issue-repasos-preventa',
  templateUrl: './issue-repasos-preventa.component.html',
  styleUrls: ['./issue-repasos-preventa.component.scss'],
})
export class IssueRepasosPreventaComponent implements OnInit, OnDestroy {

  @Input() issueFront: IssueFront;
  @Input() allCardsSelected: boolean;
  checkboxModel = false;
  cardSelected = false;
  issueFrontSelection: IssueFrontSelection = null;
  reparada = false;
  private selectionAllCardsSubscription: Subscription;

  constructor(private modalCtrl: ModalController,
              private popOverCtrl: PopoverController,
              private portalProveedorService: PortalProveedorService) { }

  ngOnDestroy(): void {
    if (this.selectionAllCardsSubscription) {
      this.selectionAllCardsSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.issueFrontSelection = {
      selection: false,
      id: this.issueFront.id
    };
    this.checkboxModel = this.allCardsSelected;
  }

  reparar() {
    // TODO: falta ver el back para ver la implementacion en el front
  }

  async conformOk() {
    // TODO: falta ver la implementacion en el back
  }

  async faltaMaterial() {
    const modal = await this.modalCtrl.create({
      component: FaltaMaterialComponent,
      componentProps: {
        isModal: true
      }
    });
    await modal.present();
    modal.onDidDismiss().then(resp => {
      if (resp.data) {
        const commentToSend = resp.data.commentToSend;
        this.enviarComentario(commentToSend);
      }
    });
  }

  async addComentario(value: string) {
    const modal = await this.modalCtrl.create({
      component: AddComentarioModalComponent,
      componentProps: {
        isModal: true,
        comment: value
      }
    });
    await modal.present();
    modal.onDidDismiss().then(resp => {
      if (resp.data) {
        const commentToSend = resp.data.commentToSend;
        this.enviarComentario(commentToSend);
      }
    });
  }
  enviarComentario(commentToSend: string) {
    // TODO: falta ver la implementacion
  }

  selectCard() {
    if (this.checkboxModel) {
      this.issueFrontSelection.selection = true;
    } else {
      this.issueFrontSelection.selection = false;
    }
    this.portalProveedorService.selectionCardEvent.emit(this.issueFrontSelection);
  }

  async abrirDescripcion(value: string) {
    if (value && value.length > 0) {
      const modal = await this.modalCtrl.create({
        component: ElipsisModalComponent,
        componentProps: {
          isModal: true,
          descripcion: value
        }
      });
      await modal.present();
    }
  }

  async openContactData(ev: any) {
    const popover = await this.popOverCtrl.create({
      component: ContactDataComponent,
      event: ev,
      componentProps: {
        firstName: this.issueFront.contact_firstname,
        lastName: this.issueFront.contact_lastname,
        phone: this.issueFront.contact_phone,
        email: this.issueFront.contact_email
      }
    });
    return await popover.present();
  }

  async openIssueImage(ev: Event) {
    const modalCtrl = await this.modalCtrl.create({
      component: IssueImageComponent,
      componentProps: {
        issueFront: this.issueFront,
        isModal: true
      }

    });
    return await modalCtrl.present();
  }
}
